import React, { useEffect, useState, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import BookCard from '../components/BookCard';
import { getBooksApi } from '../utils/api';

const GENRES = ['All','Fiction','Non-Fiction','Mystery','Romance','Sci-Fi','Fantasy','Biography','Self-Help','Horror','Thriller','History','Other'];
const SORTS  = [
  { v:'newest',     l:'Newest' },
  { v:'popular',    l:'Most Read' },
  { v:'rating',     l:'Top Rated' },
  { v:'price-low',  l:'Price ↑' },
  { v:'price-high', l:'Price ↓' },
];

export default function BooksPage() {
  const [sp, setSp] = useSearchParams();
  const [books, setBooks] = useState([]);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [searchInput, setSearchInput] = useState(sp.get('search')||'');

  const genre  = sp.get('genre')  || 'All';
  const sort   = sp.get('sort')   || 'newest';
  const search = sp.get('search') || '';
  const page   = +sp.get('page')  || 1;

  const setParam = (k,v) => { const n=new URLSearchParams(sp); n.set(k,v); if(k!=='page')n.set('page','1'); setSp(n); };

  const fetch = useCallback(() => {
    setLoading(true);
    const params = { sort, page, limit:12 };
    if (genre !== 'All') params.genre = genre;
    if (search) params.search = search;
    getBooksApi(params)
      .then(({data}) => { setBooks(data.books); setTotal(data.total); setPages(data.pages); })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [genre, sort, search, page]);

  useEffect(() => { fetch(); }, [fetch]);

  return (
    <div style={{ minHeight:'80vh' }}>
      {/* Header */}
      <div style={{ background:'linear-gradient(135deg, var(--bg2), var(--bg))', borderBottom:'1px solid var(--border)', padding:'48px 0 36px' }}>
        <div className="container">
          <h1 style={{ fontFamily:'var(--font-d)', fontSize:'2.8rem', fontWeight:600, color:'var(--text)', marginBottom:8 }}>Library</h1>
          <p style={{ color:'var(--text3)' }}>{total} {total===1?'book':'books'} available</p>
        </div>
      </div>

      <div className="container" style={{ padding:'36px 24px 80px' }}>
        {/* Filters row */}
        <div style={{ display:'flex', gap:12, flexWrap:'wrap', marginBottom:20, alignItems:'center' }}>
          <form onSubmit={e=>{ e.preventDefault(); setParam('search',searchInput); }} style={{ display:'flex', gap:8, flex:1, minWidth:200 }}>
            <input value={searchInput} onChange={e=>setSearchInput(e.target.value)} placeholder="Search books…" className="form-control" style={{ flex:1 }} />
            <button type="submit" className="btn btn-gold btn-sm">Go</button>
          </form>
          <select value={sort} onChange={e=>setParam('sort',e.target.value)} className="form-control" style={{ width:'auto', minWidth:140 }}>
            {SORTS.map(s=><option key={s.v} value={s.v}>{s.l}</option>)}
          </select>
        </div>

        {/* Genre pills */}
        <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:36 }}>
          {GENRES.map(g => (
            <button key={g} onClick={()=>setParam('genre',g)} style={{
              padding:'7px 16px', border:`1.5px solid ${genre===g?'var(--gold)':'var(--border2)'}`,
              borderRadius:20, background: genre===g ? 'rgba(232,197,71,0.12)' : 'transparent',
              color: genre===g ? 'var(--gold)' : 'var(--text2)', cursor:'pointer',
              fontSize:'0.78rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.06em',
              fontFamily:'var(--font-b)', transition:'all 0.2s',
            }}>{g}</button>
          ))}
        </div>

        {loading ? <div className="spinner" /> : books.length === 0 ? (
          <div style={{ textAlign:'center', padding:'80px 0', color:'var(--text3)', display:'flex', flexDirection:'column', alignItems:'center', gap:16 }}>
            <span style={{ fontSize:'3rem' }}>📭</span>
            <p>No books found. Try different filters.</p>
          </div>
        ) : (
          <>
            <div className="grid-books">
              {books.map(b => <BookCard key={b._id} book={b} />)}
            </div>
            {pages > 1 && (
              <div style={{ display:'flex', justifyContent:'center', gap:8, marginTop:48 }}>
                {Array.from({length:pages},(_,i)=>i+1).map(p => (
                  <button key={p} onClick={()=>setParam('page',p)} style={{
                    width:38, height:38, border:`1.5px solid ${page===p?'var(--gold)':'var(--border2)'}`,
                    borderRadius:8, background: page===p ? 'rgba(232,197,71,0.15)' : 'transparent',
                    color: page===p ? 'var(--gold)' : 'var(--text2)', cursor:'pointer',
                    fontWeight:700, fontFamily:'var(--font-b)', transition:'all 0.2s',
                  }}>{p}</button>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
